export const labelForDepartment = {
  life: "생활스포츠지도사",
  pro: "전문스포츠지도사",
};

export const getTimezoneOffsetAddedTime = () => {
  const currDate = new Date();
  const timezoneOffsetAddedTime = new Date(
    Date.UTC(
      currDate.getFullYear(),
      currDate.getMonth(),
      currDate.getDate(),
      currDate.getHours(),
      currDate.getMinutes(),
      currDate.getSeconds()
    )
  );
  return timezoneOffsetAddedTime;
};
